(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 2205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9117);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(835);
/* harmony import */ var _components_utils_local_policy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);






var Contact = function Contact(props) {
  var storeData = props.storeData,
      themeData = props.themeData;
  var storeName = storeData.storeName;
  var contacts = storeData !== null && storeData !== void 0 && storeData.legalInfo && storeData !== null && storeData !== void 0 && storeData.legalInfo.contacts ? storeData === null || storeData === void 0 ? void 0 : storeData.legalInfo.contacts : _components_utils_local_policy__WEBPACK_IMPORTED_MODULE_2__/* .localLegalInfo.contacts */ .y.contacts;
  contacts = contacts.replace("{{store email}}", storeData.email ? storeData.email : "NA");
  contacts = contacts.replace("{{store phone}}", storeData.supportPhone ? storeData.supportPhone : "NA");
  contacts = contacts.replaceAll("{{store instagram}}", storeData.instagramHandle);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("main", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
        className: "sidepage-title",
        children: "Contact Us"
      }), contacts.trim() != "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "sidepage-content",
        dangerouslySetInnerHTML: {
          __html: contacts
        }
      }) : null]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      theme: themeData
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Contact);

/***/ }),

/***/ 6405:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(2205);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3365,5407,7333,932,9774,2888,179], function() { return __webpack_exec__(6405); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);